module.exports = __webpack_public_path__ + "media/images/countryrect/uk-deb30c9645810052363550796a68928c.svg";